import useGetApi from 'src/api/useGetApi';

export interface AddressSchema {
  name?: string;
  street?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  country?: string;
}

export interface LineItem {
  description?: string;
  quantity?: number;
  unitPrice?: number;
  amount?: number;
  unit?: string;
  itemCode?: string;
  taxAmount?: number;
  discountAmount?: number;
}

export interface InvoiceDTO {
  id: string;
  organizationId: string;
  sourceEmailId?: string;
  documentId?: string;
  invoiceNumber?: string;
  invoiceDate?: string;
  dueDate?: string;
  totalAmount?: number;
  currency: string;
  vendorName?: string;
  vendorEmail?: string;
  vendorAddress?: AddressSchema;
  billToAddress?: AddressSchema;
  lineItems?: LineItem[];
  createdAt: Date;
  updatedAt: Date;
  document?: {
    id: string;
    name: string;
    originalFileName: string;
    mimeType?: string;
    signedUrl?: string;
  };
  rawData?: {
    potentialErrors: string[];
  };
}

type ApiResponse = {
  invoices: InvoiceDTO[];
};

const useDemoInvoices = () => {
  return useGetApi<ApiResponse>({
    endpoint: 'accounts-payable/invoices',
    options: {},
  });
};

export default useDemoInvoices;
